import * as angular from "angular";

angular
.module('bringoz.admin.oms')
.component('omsShipmentAssignTable', {
  bindings: {
    suppliers: '<',
    onAssign: '&',
  },
  template: require('./oms-shipment-assign-table.html').default
});
